import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface ParkingCard {
  cardNo: string;
  name: string;
  startDate: string;
  expiryDate: string;
  type: string;
  status: string;
}

export interface TenantCompanyForm {
  [key: string]: any;
  id: number;
  name: string;
  address: string;
  phone: string;
  taxId: string;
  contactPerson: string;
  branch: string;
  remark: string;
  limitCard: number;
  tenantType: string;
  provider: string;
  stamp: string;
  wh: number;
  site: string;
  quotaInAndOut: number;
  quotaUsed: string;
  carUsed: string;
  parkingCards: ParkingCard[];
}

@Component({
  selector: 'app-modal-tenant-company',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-tenant-company.component.html',
  styleUrl: './modal-tenant-company.component.css'
})
export class ModalTenantCompanyComponent implements OnInit {
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() data: any = null;
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  constructor() { }

  isLoading: boolean = false;
  title: string = 'จัดการบริษัทผู้เช่า';

  formData: TenantCompanyForm = {
    id: 0,
    name: '',
    address: '',
    phone: '',
    taxId: '',
    contactPerson: '',
    branch: '',
    remark: '',
    limitCard: 0,
    tenantType: '',
    provider: '',
    stamp: '',
    wh: 0.00,
    site: '',
    quotaInAndOut: 0,
    quotaUsed: '0 / 0',
    carUsed: '0 / 0',
    parkingCards: []
  };

  tenantTypes: string[] = ['นิติบุคคล', 'บุคคลธรรมดา'];
  providers: string[] = ['The Market', 'Around Lifestyle Station'];
  sites: string[] = ['The Market', 'Around Lifestyle Station'];

  // Custom Dropdown State
  activeDropdown: string | null = null;

  ngOnInit(): void {
    if (this.mode === 'edit' && this.data) {
      // Map data from TenantCompany model to Form structure
      this.formData = {
        ...this.formData,
        ...this.data,
        provider: this.data.providerName || '',
        site: this.data.siteName || '',
        quotaInAndOut: this.data.reserveQuota || 0,
        quotaUsed: `${this.data.reserveUsed || 0} / ${this.data.reserveQuota || 0}`,
        carUsed: `${this.data.carUsed || 0} / ${this.data.carTotal || 0}`,
        parkingCards: this.data.parkingCards || []
      };
      
      // If no cards in mock, add a sample one for edit mode
      if (this.formData.parkingCards.length === 0 && this.formData.id === 1) {
        this.formData.parkingCards = [
          { cardNo: '1000001', name: 'พนักงาน A', startDate: '2024-01-01', expiryDate: '2024-12-31', type: 'ทั่วไป', status: 'Active' }
        ];
      }
    }
  }

  addParkingCard() {
    this.formData.parkingCards.push({
      cardNo: '',
      name: '',
      startDate: new Date().toISOString().split('T')[0],
      expiryDate: '',
      type: 'ทั่วไป',
      status: 'Active'
    });
  }

  removeParkingCard(index: number) {
    this.formData.parkingCards.splice(index, 1);
  }

  onSave() {
    this.isLoading = true;
    setTimeout(() => {
      this.save.emit(this.formData);
      this.isLoading = false;
    }, 800);
  }

  onClose() {
    this.close.emit();
  }

  // Custom Dropdown Methods
  toggleDropdown(name: string, event: Event) {
    event.stopPropagation();
    this.activeDropdown = this.activeDropdown === name ? null : name;
  }

  selectOption(field: string, value: any) {
    this.formData[field] = value;
    this.activeDropdown = null;
  }

  closeDropdowns() {
    this.activeDropdown = null;
  }
}
